import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { logoutUser } from "../actions/authentication";
import { requestBatches } from "../actions/batches";
import { changeCulture, getLanguageContext } from "../actions/general";
import { useLanguageFromNowOn, keepCurrentLanguage, useLanguageThisVisit } from "../actions/languageChoice";
import { navigateToBatch, navigateToLogin, navigateToWidget } from "../actions/router";
import { getAuth } from "../actions/authentication.localStorage";
import { getCulture } from "../actions/culture";
import { withBackgroundHeightAdjust } from "../components/WithBackgroundHeightAdjust";
import Batches from "../components/Batches";
import {getSurveyBackUrl} from "../util/helpers";

class BatchesContainer extends Component {
	componentDidMount() {
		this.props.onMount(this.props.shouldRequest);
		this.addUserIdToDatadogLogs();
		if (!this.props.resolvedCulture) {
			this.props.onEnsureLanguageContext();
		}
	}

	addUserIdToDatadogLogs = () => {
		const authentication = getAuth();

		//add userId to Datadog logs
		if (authentication && authentication.id) {
			window.DD_LOGS && window.DD_LOGS.addLoggerGlobalContext("userId", authentication.id);
		}
	};

	render() {
		return <Batches {...this.props} fetching={this.props.fetching} />;
	}
}

BatchesContainer.propTypes = {
	shouldRequest: PropTypes.bool,
	fetching: PropTypes.bool,
	onMount: PropTypes.func,
	resolvedCulture: PropTypes.string,
	onEnsureLanguageContext: PropTypes.func,
};

const mapStateToProps = (state) => {
	var authentication = getAuth();

	return {
		culture: getCulture(state),
		languages: state.general.languages,
		fetching: state.questions.fetching,
		username: authentication ? authentication.name : null,
		shouldRequest: !state.questions.requested,
		widgetEnabled: state.general.widget.enabled,
		batches: state.questions.batches ? state.questions.batches.filter((batch) => !batch.submitted) : [],
		questionSettings: state.questions.questionSettings,
		resolvedCulture: state.general.resolvedCulture,
		savedCulture: state.general.savedCulture,
	};
};

const mapDispatchToProps = (dispatch, { history }) => {
	return {
		onCultureChange: function (culture) {
			dispatch(changeCulture(culture));
			dispatch(requestBatches());
		},
		onUseLanguageFromNowOn: function (newCulture) {
			dispatch(useLanguageFromNowOn(newCulture));
		},
		onKeepCurrentLanguage: function (currentCulture) {
			dispatch(keepCurrentLanguage(currentCulture));
		},
		onUseLanguageThisVisit: function (newCulture) {
			dispatch(useLanguageThisVisit(newCulture));
		},
		onEnsureLanguageContext: function () {
			dispatch(getLanguageContext());
		},
		onLogout: function () {
			dispatch(logoutUser()).then(navigateToLogin(history));
		},
		onBatchClick: function (batch, culture) {
			if(batch.url) {
				// need to update the current url. "/batches" page will fail
				window.history.replaceState(null, "", window.location.href.replace("/batches", ""));
				window.location.assign(getSurveyBackUrl(batch.url, culture));
			} else {
				navigateToBatch(batch.id, history);
			}
		},
		onWidgetClick: function () {
			navigateToWidget(history);
		},
		onMount: function (shouldRequest) {
			if (!shouldRequest) return;
			dispatch(requestBatches()).then((result) => {
				if (!result.success && result.status === 401) {
					dispatch(logoutUser()).then(navigateToLogin(history));
				}
			});
		},
	};
};

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(withBackgroundHeightAdjust(BatchesContainer))
);
